import Chole from "../assets/chhola.jpg";
import Dosa from "../assets/dosa.jpg";
import Paneer from "../assets/paneer.jpg";
import Idli from "../assets/idli.jpg";
import Gujrati from "../assets/gujrati.jpeg";
import Rajasthani from "../assets/rajasthani.jpg";

export const MenuList = [
  {
    name: "Chole Bhature",
    image: Chole,
    price: 250,
  },
  {
    name: "Masala Dosa",
    image: Dosa,
    price: 280,
  },
  {
    name: "Butter Paneer",
    image: Paneer,
    price: 350,
  },
  {
    name: "Idli Vada",
    image: Idli,
    price: 230,
  },
  {
    name: "Gujrati Thali",
    image: Gujrati,
    price: 450,
  },
  {
    name: "Rajasthani Thali",
    image: Rajasthani,
    price: 499,
  },
];
